import { render } from "./Urobond600Page.vue?vue&type=template&id=484341f2"
import script from "./Urobond600Page.vue?vue&type=script&lang=js"
export * from "./Urobond600Page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__